// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LGmJK","type":"styles_type__2nssw","choices":"styles_choices__DAkGX"};